export default __webpack_public_path__ + "static/media/checkbox_ico_off.5f9679ec.svg";